"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showSuccessNotification = exports.showFailureNotification = exports.isSuverySubmitted = exports.isSurveyEnabled = exports.isSubmitInProgress = exports.isGetQuestionsInProgress = exports.hideSuccessNotification = void 0;
var _type = require("./type");
var showSuccessNotification = exports.showSuccessNotification = function showSuccessNotification() {
  return {
    type: _type.SHOW_SUCCESS_NOTIFICATION
  };
};
var hideSuccessNotification = exports.hideSuccessNotification = function hideSuccessNotification() {
  return {
    type: _type.HIDE_SUCCESS_NOTIFICATION
  };
};
var showFailureNotification = exports.showFailureNotification = function showFailureNotification() {
  return {
    type: _type.SHOW_FAILURE_NOTIFICATION
  };
};
var isSubmitInProgress = exports.isSubmitInProgress = function isSubmitInProgress(payload) {
  return {
    type: _type.IS_SUBMIT_INPROGRESS,
    payload: payload
  };
};
var isSuverySubmitted = exports.isSuverySubmitted = function isSuverySubmitted(payload) {
  return {
    type: _type.IS_SURVEY_SUBMITTED,
    payload: payload
  };
};
var isGetQuestionsInProgress = exports.isGetQuestionsInProgress = function isGetQuestionsInProgress(payload) {
  return {
    type: _type.IS_GET_QUESTIONS_INPROGRESS,
    payload: payload
  };
};
var isSurveyEnabled = exports.isSurveyEnabled = function isSurveyEnabled(payload) {
  return {
    type: _type.IS_SURVEY_ENABLED,
    payload: payload
  };
};
//# sourceMappingURL=index.js.map